import { useRef } from 'react'
import * as S from './FullScreenVideoSection.styles'
import { useTransform, useScroll } from 'motion/react'
import useScreenSize from '../../../../hooks/useScreenSize'

type Props = {
  cldId: string
  folder?: string
  videoText: string
}

export default function FullScreenVideoSection({
  cldId,
  folder,
  videoText,
}: Props) {
  const isMediumScreen = useScreenSize('md')
  // motion binds the scroll timeline to whatever target the first render had,
  // so the target must be a ref object that is filled in later, not a value
  // read from a ref during render.
  const containerRef = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'start start'],
  })
  const translateY = useTransform(scrollYProgress, [0, 1], [5, 0])
  const scale = useTransform(scrollYProgress, [0.6, 1], [0.9, 1])
  const opacity = useTransform(scrollYProgress, [0, 0.8], [0, 1])

  return (
    <S.FullScreenVideo
      ref={(video) => {
        containerRef.current = video?.containerRef.current ?? null
      }}
      cldId={cldId}
      folder={folder}
      style={isMediumScreen ? { opacity: 1 } : { opacity, translateY, scale }}
      name="Fullscreen"
      type="Video"
      cldWidth={isMediumScreen ? 2000 : undefined}
    >
      <S.FullScreenVideoWrapper>
        <S.FullScreenVideoText>{videoText}</S.FullScreenVideoText>
      </S.FullScreenVideoWrapper>
    </S.FullScreenVideo>
  )
}
